import { ScoreAddress } from "../constants";
import ScoreABI from "../contracts/Score.sol/Score.json";

function ScoreContract(kit) {
  try {
    const Score = new kit.web3.eth.Contract(ScoreABI.abi, ScoreAddress);
    return Score;
  } catch (error) {
    console.log(error);
  }
}

export async function scoreOfAddress(kit, address) {
  try {
    const Score = ScoreContract(kit);
    const res = await Score.methods.getScoreByAddress(address).call();
    console.log("Score", res);
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function rewardsOfAddress(kit, address) {
  try {
    const Score = ScoreContract(kit);
    const res = await Score.methods.getPendingRewardByAddress(address).call();
    console.log("Reward", res);
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function updateRewards(kit, address) {
  try {
    const Score = ScoreContract(kit);
    const res = await Score.methods.updateRewards().send({ from: address });
    console.log(res);
    return res;
  } catch (error) {
    console.log(error);
  }
}

export async function claimReward(performActions, address) {
  try {
    performActions(async (kit) => {
      const Score = ScoreContract(kit);
      const tx = await Score.methods.claim().send({ from: address });
      console.log(await tx);
    });
  } catch (error) {
    console.log(error);
  }
}
